/**
 * Public barrel export for the CompactPlayerRow molecule (SE-6945 fidelity
 * pass). Default export is the CONTAINER (bound add handler); the raw view is
 * exported for drag-shell wrappers that bind their own handlers.
 * @module features/player-kanban/components/molecules/AddPlayersRow/CompactPlayerRow
 */
export { default } from "./CompactPlayerRowContainer";
export { default as CompactPlayerRowView } from "./CompactPlayerRowView";
export type { CompactPlayerRowContainerProps } from "./CompactPlayerRowContainer";
export type { CompactPlayerRowViewProps } from "./CompactPlayerRowView";
